module.exports = __webpack_public_path__ + "static/media/03-banner-03-saccaro@2x.746e1cd8.jpg";